import graphql from "babel-plugin-relay/macro";
import { useAtomValue, useSetAtom } from "jotai";
import { Suspense, useEffect } from "react";
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from "react-relay";

import { StoreProductOrderFooter } from "../../StoreProductOrderFooter";
import { goToPageAtom, memberPackageIdAtom, orderIdAtom } from "../atoms";
import { StorePackagePurchaseFooterQuery } from "./__generated__/StorePackagePurchaseFooterQuery.graphql";

export const StorePackagePurchaseFooter = () => {
  const memberPackageId = useAtomValue(memberPackageIdAtom);
  const orderId = useAtomValue(orderIdAtom);

  const [queryRef, loadQuery] = useQueryLoader<StorePackagePurchaseFooterQuery>(
    StorePackagePurchaseFooterQueryString
  );

  useEffect(() => {
    if (orderId && memberPackageId) {
      loadQuery(
        {
          memberPackageId,
          orderId,
        },
        { fetchPolicy: "store-and-network" }
      );
    }
  }, [orderId, memberPackageId, loadQuery]);

  return (
    <Suspense>
      {queryRef ? (
        <StorePackagePurchaseFooterInner queryRef={queryRef} />
      ) : null}
    </Suspense>
  );
};

type InnerProps = {
  queryRef: PreloadedQuery<StorePackagePurchaseFooterQuery>;
};

const StorePackagePurchaseFooterInner = ({ queryRef }: InnerProps) => {
  const goToPage = useSetAtom(goToPageAtom);

  const data = usePreloadedQuery(
    StorePackagePurchaseFooterQueryString,
    queryRef
  );
  const order = data.order;
  const memberPackage = data.memberPackage;

  const onSuccessfulPurchase = () => {
    if (memberPackage?.id) {
      goToPage({ page: "SUCCESS", memberPackageId: memberPackage.id });
    }
  };

  return (
    <StoreProductOrderFooter
      orderRef={order}
      memberPackageRef={memberPackage}
      onSuccessfulPurchase={onSuccessfulPurchase}
    />
  );
};

const StorePackagePurchaseFooterQueryString = graphql`
  query StorePackagePurchaseFooterQuery($memberPackageId: ID!, $orderId: ID!) {
    memberPackage: node(id: $memberPackageId) {
      ... on MemberPackage {
        id
        ...StoreProductOrderFooter_memberPackage
      }
    }
    order: node(id: $orderId) {
      ... on Order {
        ...StoreProductOrderFooter_order
      }
    }
  }
`;
